/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Table_FleetInputs */

const en_clients_table_fleet = /** @type {(inputs: Clients_Table_FleetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fleet`)
};

const pt_br2_clients_table_fleet = /** @type {(inputs: Clients_Table_FleetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frota`)
};

/**
* | output |
* | --- |
* | "Fleet" |
*
* @param {Clients_Table_FleetInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_table_fleet = /** @type {((inputs?: Clients_Table_FleetInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Table_FleetInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_table_fleet(inputs)
	return pt_br2_clients_table_fleet(inputs)
});